module.exports = __webpack_public_path__ + "img/evaluateConfig.6a5f9e9e.svg";